import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { adminApi } from '@/lib/adminApi';
import { groupByDomain } from '@/lib/biomarkers';
import { DomainPill } from '@/components/DomainPill';
import { AdminPage } from '@/admin';

export function DomainsPage() {
  const q = useQuery({ queryKey: ['biomarkers'], queryFn: () => adminApi.biomarkers.list() });
  const groups = groupByDomain(q.data?.biomarkers ?? []);
  return (
    <AdminPage title="Domains" description="The grouping tier of the data hierarchy — each domain routes to a board specialist and collects its biomarkers. Derived from the biomarker registry (read-only).">
      {q.isLoading ? <p className="text-body-sm text-text-muted">Loading…</p> : null}
      {q.isError ? <p className="text-body-sm text-flagged">Could not load biomarkers.</p> : null}
      <div className="flex flex-col gap-2">
        {groups.map((g) => (
          <Link key={g.domain} to={`/admin/domains/${encodeURIComponent(g.domain)}`}
            className="flex items-center justify-between gap-3 rounded border border-border bg-surface px-13 py-2.5 hover:border-accent">
            <DomainPill domain={g.domain} />
            <span className="text-[12px] text-text-muted">{g.biomarkers.length} biomarkers ›</span>
          </Link>
        ))}
      </div>
    </AdminPage>
  );
}
